export default {
  KHONG_TIM_THAY_LAYER: 'Không tìm thấy lớp dữ liệu',
  CO_LOI_XAY_RA: 'Có lỗi xảy ra trong quá trình thực hiện',
  THANH_CONG: 'Thao thác thành công',
  THAT_BAI: 'Thao tác thất bại'
};

export const MSG_AUTH = {
  LOGOUT_SUCESS: 'Đăng xuất thành công'
};

export const MSG_MAP = {
  LAYERINFO_FAIL: 'Có lỗi xảy ra trong quá trình tải quyền truy cập lớp dữ liệu'
};
export const MSG_CHANGE_PASSWORD = {
  FAIL_PASSWORD: 'Mật khẩu hiện tại không đúng',
  UN_EQUAL_PASSWORD: "Xác nhận mật khẩu không trùng nhau"
};
